import { FeatureFlagEnum } from "@pharaday/feature-flag";

import { ApplicationTypeEnum } from "../core/domain/enums/application-type.enum";

export const getAppFeatureFlag = (type: ApplicationTypeEnum): FeatureFlagEnum | undefined => {
  switch (type) {
    case ApplicationTypeEnum.PORT:
      return FeatureFlagEnum.PORT_APP;

    case ApplicationTypeEnum.CHARTERER:
      return FeatureFlagEnum.CHARTERER_APP;

    case ApplicationTypeEnum.TRANSHIPMENT:
      return FeatureFlagEnum.TRANSHIPMENT_APP;

    case ApplicationTypeEnum.SMART_SEARCH:
      return FeatureFlagEnum.SMART_SEARCH_APP;

    case ApplicationTypeEnum.PORT_CALL:
      return FeatureFlagEnum.PORT_CALL_APP;

    case ApplicationTypeEnum.TERMINAL:
      return FeatureFlagEnum.TERMINAL_APP;

    default:
      return undefined;
  }
};
